// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as SitemapDotxmlRouteImport } from './routes/sitemap[.]xml'
import { Route as Char123LocaleChar125RouteRouteImport } from './routes/{-$locale}/route'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminCategoriesRouteImport } from './routes/admin.categories'
import { Route as AdminPricingRouteImport } from './routes/admin.pricing'
import { Route as AdminRequestsRouteImport } from './routes/admin.requests'
import { Route as AdminTranslationsRouteImport } from './routes/admin.translations'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as Char123LocaleChar125IndexRouteImport } from './routes/{-$locale}/index'
import { Route as Char123LocaleChar125AboutRouteImport } from './routes/{-$locale}/about'
import { Route as Char123LocaleChar125AffiliateProgramRouteImport } from './routes/{-$locale}/affiliate-program'
import { Route as Char123LocaleChar125ContactsRouteImport } from './routes/{-$locale}/contacts'
import { Route as Char123LocaleChar125CostRouteImport } from './routes/{-$locale}/cost'
import { Route as Char123LocaleChar125IntegrationRouteImport } from './routes/{-$locale}/integration'
import { Route as Char123LocaleChar125OnboardingRouteImport } from './routes/{-$locale}/onboarding'
import { Route as Char123LocaleChar125PlanningRouteImport } from './routes/{-$locale}/planning'
import { Route as Char123LocaleChar125PricesRouteImport } from './routes/{-$locale}/prices'
import { Route as Char123LocaleChar125PrivacyRouteImport } from './routes/{-$locale}/privacy'
import { Route as Char123LocaleChar125ProductionRouteImport } from './routes/{-$locale}/production'
import { Route as Char123LocaleChar125PurchasesRouteImport } from './routes/{-$locale}/purchases'
import { Route as Char123LocaleChar125RegistrationRouteImport } from './routes/{-$locale}/registration'
import { Route as Char123LocaleChar125RegistrationDemoRouteImport } from './routes/{-$locale}/registration-demo'
import { Route as Char123LocaleChar125RegistrationPartnersRouteImport } from './routes/{-$locale}/registration-partners'
import { Route as Char123LocaleChar125ReusingContentRouteImport } from './routes/{-$locale}/reusing-content'
import { Route as Char123LocaleChar125RoiCalculatorRouteImport } from './routes/{-$locale}/roi-calculator'
import { Route as Char123LocaleChar125SalesRouteImport } from './routes/{-$locale}/sales'
import { Route as Char123LocaleChar125SchedulingRouteImport } from './routes/{-$locale}/scheduling'
import { Route as Char123LocaleChar125SolutionFinderRouteImport } from './routes/{-$locale}/solution-finder'
import { Route as Char123LocaleChar125StocksRouteImport } from './routes/{-$locale}/stocks'
import { Route as Char123LocaleChar125TechnicalDataRouteImport } from './routes/{-$locale}/technical-data'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as AdminContentKindRouteImport } from './routes/admin.content.$kind'
import { Route as Char123LocaleChar125AddonsIndexRouteImport } from './routes/{-$locale}/addons.index'
import { Route as Char123LocaleChar125AddonsSlugRouteImport } from './routes/{-$locale}/addons.$slug'
import { Route as Char123LocaleChar125BlogIndexRouteImport } from './routes/{-$locale}/blog.index'
import { Route as Char123LocaleChar125BlogSlugRouteImport } from './routes/{-$locale}/blog.$slug'
import { Route as Char123LocaleChar125CasesIndexRouteImport } from './routes/{-$locale}/cases.index'
import { Route as Char123LocaleChar125CasesSlugRouteImport } from './routes/{-$locale}/cases.$slug'
import { Route as Char123LocaleChar125IndustriesIndexRouteImport } from './routes/{-$locale}/industries.index'
import { Route as Char123LocaleChar125IndustriesSlugRouteImport } from './routes/{-$locale}/industries.$slug'
import { Route as Char123LocaleChar125IntegrationsSlugRouteImport } from './routes/{-$locale}/integrations.$slug'
import { Route as Char123LocaleChar125NewsIndexRouteImport } from './routes/{-$locale}/news.index'
import { Route as Char123LocaleChar125NewsSlugRouteImport } from './routes/{-$locale}/news.$slug'
import { Route as AdminContentKindIndexRouteImport } from './routes/admin.content.$kind.index'
import { Route as AdminContentKindIdRouteImport } from './routes/admin.content.$kind.$id'
import { Route as ApiPublicMediaSplatRouteImport } from './routes/api/public/media/$'

const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const SitemapDotxmlRoute = SitemapDotxmlRouteImport.update({
            id: '/sitemap.xml',path: '/sitemap.xml',getParentRoute: () => rootRouteImport
          })
const Char123LocaleChar125RouteRoute = Char123LocaleChar125RouteRouteImport.update({
            id: '/{-$locale}',path: '/{-$locale}',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminCategoriesRoute = AdminCategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => AdminRoute
          })
const AdminPricingRoute = AdminPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => AdminRoute
          })
const AdminRequestsRoute = AdminRequestsRouteImport.update({
            id: '/requests',path: '/requests',getParentRoute: () => AdminRoute
          })
const AdminTranslationsRoute = AdminTranslationsRouteImport.update({
            id: '/translations',path: '/translations',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })
const Char123LocaleChar125IndexRoute = Char123LocaleChar125IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125AboutRoute = Char123LocaleChar125AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125AffiliateProgramRoute = Char123LocaleChar125AffiliateProgramRouteImport.update({
            id: '/affiliate-program',path: '/affiliate-program',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125ContactsRoute = Char123LocaleChar125ContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125CostRoute = Char123LocaleChar125CostRouteImport.update({
            id: '/cost',path: '/cost',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125IntegrationRoute = Char123LocaleChar125IntegrationRouteImport.update({
            id: '/integration',path: '/integration',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125OnboardingRoute = Char123LocaleChar125OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125PlanningRoute = Char123LocaleChar125PlanningRouteImport.update({
            id: '/planning',path: '/planning',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125PricesRoute = Char123LocaleChar125PricesRouteImport.update({
            id: '/prices',path: '/prices',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125PrivacyRoute = Char123LocaleChar125PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125ProductionRoute = Char123LocaleChar125ProductionRouteImport.update({
            id: '/production',path: '/production',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125PurchasesRoute = Char123LocaleChar125PurchasesRouteImport.update({
            id: '/purchases',path: '/purchases',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125RegistrationRoute = Char123LocaleChar125RegistrationRouteImport.update({
            id: '/registration',path: '/registration',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125RegistrationDemoRoute = Char123LocaleChar125RegistrationDemoRouteImport.update({
            id: '/registration-demo',path: '/registration-demo',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125RegistrationPartnersRoute = Char123LocaleChar125RegistrationPartnersRouteImport.update({
            id: '/registration-partners',path: '/registration-partners',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125ReusingContentRoute = Char123LocaleChar125ReusingContentRouteImport.update({
            id: '/reusing-content',path: '/reusing-content',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125RoiCalculatorRoute = Char123LocaleChar125RoiCalculatorRouteImport.update({
            id: '/roi-calculator',path: '/roi-calculator',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125SalesRoute = Char123LocaleChar125SalesRouteImport.update({
            id: '/sales',path: '/sales',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125SchedulingRoute = Char123LocaleChar125SchedulingRouteImport.update({
            id: '/scheduling',path: '/scheduling',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125SolutionFinderRoute = Char123LocaleChar125SolutionFinderRouteImport.update({
            id: '/solution-finder',path: '/solution-finder',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125StocksRoute = Char123LocaleChar125StocksRouteImport.update({
            id: '/stocks',path: '/stocks',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125TechnicalDataRoute = Char123LocaleChar125TechnicalDataRouteImport.update({
            id: '/technical-data',path: '/technical-data',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AdminContentKindRoute = AdminContentKindRouteImport.update({
            id: '/content/$kind',path: '/content/$kind',getParentRoute: () => AdminRoute
          })
const Char123LocaleChar125AddonsIndexRoute = Char123LocaleChar125AddonsIndexRouteImport.update({
            id: '/addons/',path: '/addons/',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125AddonsSlugRoute = Char123LocaleChar125AddonsSlugRouteImport.update({
            id: '/addons/$slug',path: '/addons/$slug',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125BlogIndexRoute = Char123LocaleChar125BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125BlogSlugRoute = Char123LocaleChar125BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125CasesIndexRoute = Char123LocaleChar125CasesIndexRouteImport.update({
            id: '/cases/',path: '/cases/',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125CasesSlugRoute = Char123LocaleChar125CasesSlugRouteImport.update({
            id: '/cases/$slug',path: '/cases/$slug',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125IndustriesIndexRoute = Char123LocaleChar125IndustriesIndexRouteImport.update({
            id: '/industries/',path: '/industries/',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125IndustriesSlugRoute = Char123LocaleChar125IndustriesSlugRouteImport.update({
            id: '/industries/$slug',path: '/industries/$slug',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125IntegrationsSlugRoute = Char123LocaleChar125IntegrationsSlugRouteImport.update({
            id: '/integrations/$slug',path: '/integrations/$slug',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125NewsIndexRoute = Char123LocaleChar125NewsIndexRouteImport.update({
            id: '/news/',path: '/news/',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125NewsSlugRoute = Char123LocaleChar125NewsSlugRouteImport.update({
            id: '/news/$slug',path: '/news/$slug',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const AdminContentKindIndexRoute = AdminContentKindIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminContentKindRoute
          })
const AdminContentKindIdRoute = AdminContentKindIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminContentKindRoute
          })
const ApiPublicMediaSplatRoute = ApiPublicMediaSplatRouteImport.update({
            id: '/api/public/media/$',path: '/api/public/media/$',getParentRoute: () => rootRouteImport
          })





const Char123LocaleChar125RouteRouteChildren = {
  Char123LocaleChar125AboutRoute: Char123LocaleChar125AboutRoute,Char123LocaleChar125AffiliateProgramRoute: Char123LocaleChar125AffiliateProgramRoute,Char123LocaleChar125ContactsRoute: Char123LocaleChar125ContactsRoute,Char123LocaleChar125CostRoute: Char123LocaleChar125CostRoute,Char123LocaleChar125IntegrationRoute: Char123LocaleChar125IntegrationRoute,Char123LocaleChar125OnboardingRoute: Char123LocaleChar125OnboardingRoute,Char123LocaleChar125PlanningRoute: Char123LocaleChar125PlanningRoute,Char123LocaleChar125PricesRoute: Char123LocaleChar125PricesRoute,Char123LocaleChar125PrivacyRoute: Char123LocaleChar125PrivacyRoute,Char123LocaleChar125ProductionRoute: Char123LocaleChar125ProductionRoute,Char123LocaleChar125PurchasesRoute: Char123LocaleChar125PurchasesRoute,Char123LocaleChar125RegistrationRoute: Char123LocaleChar125RegistrationRoute,Char123LocaleChar125RegistrationDemoRoute: Char123LocaleChar125RegistrationDemoRoute,Char123LocaleChar125RegistrationPartnersRoute: Char123LocaleChar125RegistrationPartnersRoute,Char123LocaleChar125ReusingContentRoute: Char123LocaleChar125ReusingContentRoute,Char123LocaleChar125RoiCalculatorRoute: Char123LocaleChar125RoiCalculatorRoute,Char123LocaleChar125SalesRoute: Char123LocaleChar125SalesRoute,Char123LocaleChar125SchedulingRoute: Char123LocaleChar125SchedulingRoute,Char123LocaleChar125SolutionFinderRoute: Char123LocaleChar125SolutionFinderRoute,Char123LocaleChar125StocksRoute: Char123LocaleChar125StocksRoute,Char123LocaleChar125TechnicalDataRoute: Char123LocaleChar125TechnicalDataRoute,Char123LocaleChar125IndexRoute: Char123LocaleChar125IndexRoute,Char123LocaleChar125AddonsSlugRoute: Char123LocaleChar125AddonsSlugRoute,Char123LocaleChar125BlogSlugRoute: Char123LocaleChar125BlogSlugRoute,Char123LocaleChar125CasesSlugRoute: Char123LocaleChar125CasesSlugRoute,Char123LocaleChar125IndustriesSlugRoute: Char123LocaleChar125IndustriesSlugRoute,Char123LocaleChar125IntegrationsSlugRoute: Char123LocaleChar125IntegrationsSlugRoute,Char123LocaleChar125NewsSlugRoute: Char123LocaleChar125NewsSlugRoute,Char123LocaleChar125AddonsIndexRoute: Char123LocaleChar125AddonsIndexRoute,Char123LocaleChar125BlogIndexRoute: Char123LocaleChar125BlogIndexRoute,Char123LocaleChar125CasesIndexRoute: Char123LocaleChar125CasesIndexRoute,Char123LocaleChar125IndustriesIndexRoute: Char123LocaleChar125IndustriesIndexRoute,Char123LocaleChar125NewsIndexRoute: Char123LocaleChar125NewsIndexRoute
}

const Char123LocaleChar125RouteRouteWithChildren = Char123LocaleChar125RouteRoute._addFileChildren(Char123LocaleChar125RouteRouteChildren)




const AdminContentKindRouteChildren = {
  AdminContentKindIdRoute: AdminContentKindIdRoute,AdminContentKindIndexRoute: AdminContentKindIndexRoute
}

const AdminContentKindRouteWithChildren = AdminContentKindRoute._addFileChildren(AdminContentKindRouteChildren)



const AdminRouteChildren = {
  AdminCategoriesRoute: AdminCategoriesRoute,AdminPricingRoute: AdminPricingRoute,AdminRequestsRoute: AdminRequestsRoute,AdminTranslationsRoute: AdminTranslationsRoute,AdminUsersRoute: AdminUsersRoute,AdminIndexRoute: AdminIndexRoute,AdminContentKindRoute: AdminContentKindRouteWithChildren
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  Char123LocaleChar125RouteRoute: Char123LocaleChar125RouteRouteWithChildren,AdminRoute: AdminRouteWithChildren,SitemapDotxmlRoute: SitemapDotxmlRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,ApiPublicMediaSplatRoute: ApiPublicMediaSplatRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)